import { createDynamicSlice } from ".";
import { getPendingRequestListThunk } from "../thunks/pendingRequestsThunk";

export const pendingRequestsSlice = createDynamicSlice({
  name: "pendingRequests",
  thunk: getPendingRequestListThunk,
  listMode: true,
  resetActionName: "resetPendingRequests",
});

export const pendingRequestsReducer = pendingRequestsSlice.reducer;
export const { resetPendingRequests } = pendingRequestsSlice.actions;
